import { fitHappensSupabase } from './fitHappensSupabase';
import type { WardrobeState } from '../utils/Wardrobe/wardrobe';

type WardrobeRow = { state: WardrobeState };

export async function loadCloudWardrobe(userId: string): Promise<WardrobeState | null> {
  const { data, error } = await fitHappensSupabase
    .from('fit_happens_wardrobes')
    .select('state')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) throw error;
  const state = (data as WardrobeRow | null)?.state;
  return state?.version === 1 && Array.isArray(state.garments) ? state : null;
}

export async function saveCloudWardrobe(userId: string, state: WardrobeState): Promise<void> {
  const { error } = await fitHappensSupabase.from('fit_happens_wardrobes').upsert({
    user_id: userId,
    state,
    updated_at: new Date().toISOString(),
  });
  if (error) throw error;
}

export async function deleteCloudWardrobe(userId: string): Promise<void> {
  const { error } = await fitHappensSupabase.from('fit_happens_wardrobes').delete().eq('user_id', userId);
  if (error) throw error;
}
